/* eslint-disable */
import React, { useEffect, useState} from 'react';
import { toast } from 'react-toastify';
import { getZoneAPI,getProductPlans } from '../../api/zone';
import TopBar from './TopBar';
import PlanMetrics from './PlanMetrics';
import PlanInformation from './PlanInformation';
import PaymentMethods from './PaymentMethods';
import BlockInformation from './BlockInformation';
import ZoneProperties from './ZoneProperties';
import ZoneMessaging from './ZoneMessaging';
import ZoneUsers from './ZoneUsers';
import PlanSelection from './PlanSelection';
import ProductPlans from './ProductPlans';
import PaymentSuccess from './PaymentSuccess';
import Invoices from './Invoices';
import InvoiceHistory from './invoiceHistory';
import { stripeGetNextInvoiceDate } from '../../api/zone';
import { AccountContext } from '../../providers/AccountProvider';
import Global from '../../clients/global'

const { REACT_APP_STRIPE_ENV } = process.env;

const ZoneSettings = ({ toggleZoneSettings, zoneid, showPlans = false,color }) => {
  const [zoneInfo, setZoneInfo] = useState('');
  const [zoneName, setZoneName] = useState('');
  const [showInfo, setShowInfo] = useState(showPlans);
  const [showPayment, setShowPayment] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);
  const [showInvoiceHistory, setShowInvoiceHistory] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [billingDate, setBillingDate] = useState('');
  const [startingBalance, setStartingBalance] = useState('');
  const [plan, setPlan] = useState('');
  const [productPlans,setProductPlans] = useState(null);
  const [isLoading,setIsLoading]=useState(false);
  const [plans, setPlans] = useState(null);

  useEffect(() => {
    const getZone = async () => {
      setIsLoading(true);
      let pPlans=null;
      const zoneInfo = await getZoneAPI(parseInt(Global.zoneid));
      setZoneInfo(zoneInfo);
      setZoneName(zoneInfo.name);
      setPlan(zoneInfo.plan);

      //5-7-25 adding in concept of product specific plans . We load these
      //here and will pass to planselection .
      if(zoneInfo.attributes.productCode !==undefined) {
         pPlans = await getProductPlans(zoneInfo.attributes.productCode);
        if(pPlans.length>0) {
          setProductPlans(pPlans[0].plans)
        }
      }

      // console.log(zoneInfo)
      if (zoneInfo.stripeInfo.subscriptionId !== undefined) {
        const result = await stripeGetNextInvoiceDate(zoneInfo.stripeInfo);
       
        if(typeof result === 'string' && !result.includes('Error occurred')){
        const nextBillingDate = new Date(result.invoice.period_end * 1000);
        setBillingDate(nextBillingDate.toLocaleDateString('en-us'));
        setStartingBalance(result.invoice.starting_balance);
        }
      }
       let tempPlans =  REACT_APP_STRIPE_ENV === 'TEST'  ?  [
          { planId: 'plan_HBhXGxjV2AW2rb', name: 'Free', interval: 'monthly', unitPrice: 0.0 },
          { planId: 'plan_FreeAnnual', name: 'Free', interval: 'annual', unitPrice: 0.0 },
          { planId: 'price_1HowgiERqpLfk4rFR2EHqlKH', name: 'Starter', interval: 'monthly', unitPrice: 14.99},
          { planId: 'plan_HBhV1eAXLDop7I', name: 'Starter', interval: 'annual', unitPrice: 143.88 },
          { planId: 'price_1HowwGERqpLfk4rFtdRUDOKV', name: 'Pro', interval: 'monthly', unitPrice: 24.99 },
          { planId: 'plan_HBgyGtfCemI04T', name: 'Pro', interval: 'annual', unitPrice: 251.88 },
          { planId: 'price_1RMV01ERqpLfk4rF4Vr17yDx', name: 'Advanced', interval: 'monthly', unitPrice: 57.99},
          { planId: 'price_1RMWGxERqpLfk4rFMvALoZsV', name: 'Advanced', interval: 'annual', unitPrice: 576.88},
          { planId: 'price_1RMeEAERqpLfk4rFVp2ZeSri', name: 'Premium', interval: 'monthly', unitPrice: 104.99},
          { planId: 'price_1RMeIpERqpLfk4rFRwgUr53E', name: 'Premium', interval: 'annual', unitPrice: 1056.88},
        ] : [
            { planId: 'price_1IC86NERqpLfk4rFZVn2LhSR', name: 'Free', interval: 'monthly', unitPrice: 0.0 },
            { planId: 'plan_FreeAnnual', name: 'Free', interval: 'annual', unitPrice: 0.0 },
            { planId: 'price_1IC8O4ERqpLfk4rFWeGZFugS', name: 'Starter', interval: 'monthly', unitPrice: 14.99 },
            { planId: 'price_1IC8O4ERqpLfk4rFyAEVCvK2', name: 'Starter', interval: 'annual', unitPrice: 143.88 },
            { planId: 'price_1IC8bqERqpLfk4rFWyNS5BaW', name: 'Pro', interval: 'monthly', unitPrice: 24.99 },
            { planId: 'price_1IC8bqERqpLfk4rFytoeAXHC', name: 'Pro', interval: 'annual', unitPrice: 251.88 },
            { planId: 'price_1QpGZJERqpLfk4rFwa00ZMTM', name: 'Advanced', interval: 'monthly', unitPrice: 57.99},
            { planId: 'price_1QpGRGERqpLfk4rFDSKzQAYy', name: 'Advanced', interval: 'annual', unitPrice: 576.88},
            { planId: 'price_1QpGqIERqpLfk4rF4rNzOuFg', name: 'Premium', interval: 'monthly', unitPrice: 104.99},
            { planId: 'price_1QpGnpERqpLfk4rFs4fBVi3e', name: 'Premium', interval: 'annual', unitPrice: 1056.88},
          ];

          if(pPlans !=null) {
            tempPlans=pPlans[0].plans

          }


          setPlans(tempPlans)
      
      setIsLoading(false);
    };
    getZone();

  }, [zoneid]);

  const updateZone= (zInfo) => {
    setZoneName(zInfo.name);
    // zoneInfo.name = name;
    setZoneInfo(zInfo);
  };

  const updateZonePlan = (plan) => {
    
    setPlan(plan);
    setShowInfo(false);
    setShowPayment(true);
  };

  const completePayment =  (paymentDetails) => {
    
    // If plan successfully changed, update Zoneplan.plan to reflect updated plan in UI.
    setPaymentDetails(paymentDetails);
    setShowPayment(false);
   
    // 7-19-23 Updating to deal with use-case where trial pro-user downgraded to "Free" plan
    //in this situation, there is no payment/stripe info and we just updated the plan to "free"
    if(paymentDetails.status==='succeeded' && paymentDetails.paymentInfo !==undefined ) {
        let zInfo = structuredClone(zoneInfo) // need to create full /deep copy as we are setting planId in sub-object.
        zInfo.plan=paymentDetails.currentPlan.name
        zInfo.stripeInfo.planId=paymentDetails.currentPlan.planId;
        zInfo.stripeInfo.paymentInfo=[paymentDetails.paymentInfo];
        zInfo.userlicenses =paymentDetails.userlicenses;
        
        //5-15-25 add logic to update custom plan info
        if(paymentDetails.currentPlan.perUser !==undefined) {
          zInfo.attributes.planId = paymentDetails.currentPlan.planId;
          zInfo.attributes.planName = paymentDetails.currentPlan.name;
          zInfo.attributes.unitPirce = paymentDetails.currentPlan.unitPirce;
        }

        setZoneInfo(zInfo)
        setShowInvoice(true);
        
       } else if(paymentDetails.status==='succeeded' && paymentDetails.userLicenses===-1) {
        let zInfo = structuredClone(zoneInfo)
        zInfo.plan = paymentDetails.currentPlan.name;

        //5-15-25 add logic to update custom plan info
        if(paymentDetails.currentPlan.perUser !==undefined) {
          zInfo.attributes.planId = paymentDetails.currentPlan.planId;
          zInfo.attributes.planName = paymentDetails.currentPlan.name;
          zInfo.attributes.unitPirce = paymentDetails.currentPlan.unitPirce;
        }

        setZoneInfo(zInfo)
        location.reload();
       }
  };

  const cancelPayment = () => {
    setShowInfo(true);
    setShowPayment(false);
  };

  const loadBreadCrumb =(page) => {
  
    if(page==='showPayment') {
      setShowPayment(true)
      setShowInvoice(false)
      setShowInfo(false)
      setShowInvoiceHistory(false)
    } else if (page==='showInfo') {
      setShowPayment(false)
      setShowInvoice(false)
      setShowInfo(true)
      setShowInvoiceHistory(false)
    } else if (page==='home') {
      setShowPayment(false)
      setShowInvoice(false)
      setShowInfo(false)
      setShowInvoiceHistory(false)
    }
  }

  const toggleShowInfo = () => {
    setShowInfo(!showInfo);
  };

  const toggleShowInvoiceHistory = () => {
    setShowInvoiceHistory(!showInvoiceHistory);
  };

  return (
    <div
      style={{
        position: 'absolute',
        backgroundColor: 'white',
        left: '100px',
        top: '20px',
        zIndex: 10,
        height: 'calc(100vh - 100px)',
        width: 'calc(100vw - 150px)',
        // border: '1px solid black',
        borderRadius: '10px',
      }}
    >
      <TopBar
        zoneName={zoneName}
        toggleShowInfo={toggleShowInfo}
        toggleShowInvoiceHistory={toggleShowInvoiceHistory}
        toggleZoneSettings={toggleZoneSettings}
        showInfo={showInfo}
        showPayment={showPayment}
        showInvoice={showInvoice}
        showInvoiceHistory={showInvoiceHistory}
        loadBreadCrumb={loadBreadCrumb}
      />
      {!isLoading && zoneInfo != '' && !showInfo && !showPayment && !showInvoice && !showInvoiceHistory ? (
        <div style={{ display: 'flex', flexDirection: 'row', border:'1px solid #ae007b' }}>
          <div style={{ width: '70%', overflow: 'auto',height: 'calc(100vh - 170px)' }}>
            <ZoneProperties zoneInfo={zoneInfo} updateZone={updateZone} />
            <PlanMetrics zoneInfo={zoneInfo} toggleShowInfo={toggleShowInfo} />
            <div style={{ height: '20px' }}> </div>
            <ZoneMessaging zoneInfo={zoneInfo} color={color} />
            <PaymentMethods zoneInfo={zoneInfo} toggleShowInfo={toggleShowInfo} color={color} />
            <ZoneUsers zoneInfo={zoneInfo} />
            {zoneInfo.stripeInfo.paymentInfo !== undefined ? (
              <Invoices
                zoneInfo={zoneInfo}
                startingBalance={startingBalance}
                toggleShowInvoiceHistory={toggleShowInvoiceHistory}
                color={color}
              />
            ) : null}
          </div>
          <div style={{ width: '25%' }}>
            <BlockInformation zoneInfo={zoneInfo} toggleZoneSettings={toggleZoneSettings} />
          </div>
        </div>
      ) : null}
      <div style={{border:'1px solid #ae007b'}}>
      {zoneInfo !== '' && showInfo && productPlans===null ? (
        <PlanInformation
          zoneInfo={zoneInfo}
          updateZonePlan={updateZonePlan}
          toggleShowInfo={toggleShowInfo}
          billingDate={billingDate}
        />
      ) : null}
      {zoneInfo !== '' && showInfo && productPlans !=null ? (
        <ProductPlans
            plans={productPlans}
            updateZonePlan={updateZonePlan}
        />
      ) : null}
      {zoneInfo !== '' && showPayment ? (
        <PlanSelection
          zoneInfo={zoneInfo}
          plan={plan}
          plans={plans}
          color={color}
          cancelPayment={cancelPayment}
          completePayment={completePayment}
        />
      ) : null}
      {zoneInfo !== '' && showInvoice ? (
        <PaymentSuccess
          paymentDetails={paymentDetails}
          zoneName={zoneInfo.name}
          toggleZoneSettings={toggleZoneSettings}
        />
      ) : null}
      {zoneInfo !== '' && showInvoiceHistory ? (
        <InvoiceHistory zoneInfo={zoneInfo} toggleShowInvoiceHistory={toggleShowInvoiceHistory} />
      ) : null}
      </div>
    </div>
  );
};

export default ZoneSettings;
